import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import apiClient from "../../utils/api";

export default function ProductBox() {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);

  const fetchData = () => {
    apiClient
      .post(
        `get/active_products.php`,
        {},
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        // console.log(res.data);

        setData(res.data);
      });
  };

  const fetchData1 = () => {
    apiClient
      .post(
        `get/inactive_products.php`,
        {},
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        setData1(res.data);
      });
  };

  useEffect(() => {
    fetchData();
    fetchData1();
    window.scroll(0, 0);
  }, []);
  

  return (
    <>
      <h4>Active Products</h4>
      {Array.isArray(data) &&
        data.map((datas) => {
          return (
            <div className="col-lg-3 col-md-4 col-sm-6" key={datas.product_id}>
              <div
                className="card mb-4 product-wap rounded shadow"
                style={{ minHeight: "350px" }}
              >
                <div className="card rounded-0">
                  <img
                    className="card-img rounded-0 img-fluid"
                    style={{
                      height: "160px",
                      objectFit: "contain",
                    }}
                    src={datas.img1}
                    alt="jannu's Food Products"
                  />
                </div>
                <div className="card-body">
                  <h5 className="text-uppercase" style={{ fontSize: ".9em" }}>
                    {datas.product_name}&nbsp;
                    <small className="text-secondary text-capitalize">
                      {datas.weight} Gms.
                    </small>
                  </h5>
                  <h6
                    className="text-secondary text-uppercase"
                    style={{ fontSize: ".8em" }}
                  >
                    {datas.category}
                  </h6>
                  <span className="d-block text-success my-2">
                    RS.{datas.offer_price}
                  </span>
                  <Button
                    className="btn btn-success btn-sm rounded-0 shadow-sm"
                    as={Link}
                    to={`/updateProduct/${datas.product_id}`}
                  >
                    Edit Product
                  </Button>
                </div>
              </div>
            </div>
          );
        })}

      <h4>InActive Products</h4>
      {Array.isArray(data1) &&
        data1.map((datas) => {
          return (
            <div className="col-lg-3 col-md-4 col-sm-6" key={datas.product_id}>
              <div
                className="card mb-4 product-wap rounded shadow"
                style={{ minHeight: "350px" }}
              >
                <div className="card rounded-0">
                  <img
                    className="card-img rounded-0 img-fluid"
                    style={{
                      height: "160px",
                      objectFit: "contain",
                    }}
                    src={datas.img1}
                    alt="jannu's Food Products"
                  />
                </div>
                <div className="card-body">
                  <h5 className="text-uppercase" style={{ fontSize: ".9em" }}>
                    {datas.product_name}&nbsp;
                    <small className="text-secondary text-capitalize">
                      {datas.weight} Gms.
                    </small>
                  </h5>
                  <h6
                    className="text-secondary text-uppercase"
                    style={{ fontSize: ".8em" }}
                  >
                    {datas.category}
                  </h6>
                  <span className="d-block text-success my-2">
                    RS.{datas.offer_price}
                  </span>
                  <Button
                    className="btn btn-success btn-sm rounded-0 shadow-sm"
                    as={Link}
                    to={`/updateProduct/${datas.product_id}`}
                  >
                    Edit Product
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
}
